<template>
  <bcc-dialog :visible="show" @open='initData' top='10vh' width="600px" @close="handleCompanyDialog(false)">
    <h3>发起授权</h3>
    <p class="des">请通知被邀请者24小时内登录哔哩哔哩开放平台，进入【管理中心-授权管理】接受邀请，若超时未进行操作，则默认拒绝邀请</p>
    <p class="tip">uid可在【哔哩哔哩APP-我的-设置-账号资料】或【哔哩哔哩主站网页-个人中心】中查看</p>
    <bcc-form :rules="rules" ref="form" class="form-container" :model="form"  @submit.native.prevent>
      <bcc-form-item style="position: relative" label="授权角色" prop='role'>
        <bcc-select @on-change='handleChange' v-model="form.role" width="250px" class="ps-select" placeholder='请选择要授权的账号角色'>
          <bcc-option :value="option.value" v-for="(option, idx) in roleOptions" :key="idx" :label="option.label"/>
        </bcc-select>
        <bcc-popover :width="310" class="role-tips" placement="bottom" trigger="hover" :zIndex="10" >
          <slot name='content'>
            <p><span style="font-weight: bold">管理员：</span>被邀请者将获得企业信息编辑、申请应用、应用管理、授权开发者、邀请管理员等权限。</p>
              <p style="margin-top: 5px"><span style="font-weight: bold">开发者：</span>被邀请者将获得企业信息查看、被授权应用的部分管理权限；</p>
          </slot>
          <v-icon style="width: 13px;height:13px;cursor:pointer" name='info' slot="reference" />
        </bcc-popover>
      </bcc-form-item>
      <bcc-form-item :style="{marginBottom: inviteeInfo.name ? '6px':'30px' }" label="被邀请者" prop='invitee'>
        <bcc-input
          style="width:250px"
          v-model="form.invitee"
          placeholder="请输入被邀请者的uid"
        ></bcc-input>
        <bcc-popover :width="310" class="role-tips" placement="bottom" trigger="hover" :zIndex="10" >
          <slot name='content'>
            <p>uid可在【哔哩哔哩APP-我的-设置-账号资料】或【哔哩哔哩主站网页-个人中心】中查看</p>
          </slot>
          <v-icon style="width: 13px;height:13px;cursor:pointer" name='info' slot="reference" />
        </bcc-popover>
        <!-- <div class="invitee-info" v-if='inviteeInfo.name'>
          <img :src="inviteeInfo['cover-url']" alt="">
          <span class="name">{{inviteeInfo.name}}</span>
        </div> -->
      </bcc-form-item>
      <bcc-form-item label="授权权限" prop='limits'>
        <p v-if='!form.role' class="backup-des">请先选择授权角色</p>
        <bcc-checkbox-group v-if='form.role === 20' disabled class='check-box' v-model="form.limits">
          <bcc-checkbox label="企业信息编辑权限"></bcc-checkbox>
          <bcc-checkbox label="申请应用权限"></bcc-checkbox>
          <bcc-checkbox label="应用管理权限"></bcc-checkbox>
          <bcc-checkbox label="授权开发者权限"></bcc-checkbox>
          <bcc-checkbox label="邀请管理员权限"></bcc-checkbox>
        </bcc-checkbox-group>
        <p v-if='form.role === 30 && !inviteeInfo["cover-url"]' class="backup-des">请输入被邀请者的uid</p>
        <bcc-checkbox-group v-if='form.role === 30 && inviteeInfo["cover-url"]' class='check-box' v-model="form.limits">
          <p class="choose-app">请选择要授权的应用（可多选）</p>
          <div class="app-list-box">
            <bcc-checkbox :disabled='item.disabled' falseValue="" v-for="(item, idx) in appList" :key="idx" :label="item.client_id">{{item.app_name}}</bcc-checkbox>
          </div>
        </bcc-checkbox-group>
      </bcc-form-item>
    </bcc-form>
    <div slot="footer">
      <bcc-button @click="submit" size="middle" type="primary">确定</bcc-button>
      <bcc-button @click="show = false" size="middle">取消</bcc-button>
    </div>
  </bcc-dialog>
</template>

<script>
export default {
  name: 'CompanyDialog',
  data () {
    let validator1 = async(rule, value, callback) => {
      if (!value) {
        this.inviteeInfo = {}
        callback(new Error('uid不能为空'));
      } else if (value[0] === '0') {
        this.inviteeInfo = {}
        callback(new Error('请输入正确的uid'));
      }  else if (!/^[0-9]*$/.test(value)) {
        this.inviteeInfo = {}
        callback(new Error('uid格式不正确'));
      } else {
        let res = await this.getAvator(value)
        if (!res['cover-url']) {
          callback(new Error('该uid不存在'));
        } else {
          callback();
        }
      }
    }
    return {
      backupList: '',
      show: false,
      reason: '',
      appList: [],
      inviteeInfo: '',
      form: {
        role: '',
        invitee: '',
        limits: []
      },
      roleOptions: [{
        label: '管理员',
        value: 20
      }, {
        label: '开发者',
        value: 30
      }],
      rules: {
        invitee: [
          /* eslint-disable */
          { required: true, trigger: 'blur',validator: validator1}
        ],
        role: [
          { required: true }
        ],
        limits: [
          { required: true }
        ],
      },
    }
  },
  mounted () {
    [1,20].includes(this.$store.state.arcUserInfo.level) && this.fetchAppList()
  },
  methods: {
    filterAppList (inviteeInfo) {
      inviteeInfo = inviteeInfo || this.inviteeInfo
      if (!inviteeInfo.client_ids) {
        this.appList = JSON.parse(this.backupList)
      } else {
        let clients = inviteeInfo.client_ids.split(',')
        let temp = this.appList
        clients.forEach((client) => {
          let idx = temp.findIndex((item) => item.client_id === client)
          if (idx > -1) {
            temp[idx].disabled = true
          }
        })
        this.appList = temp
      }
    },
    initData () {
      this.$refs.form.resetFields()
      this.inviteeInfo = {}
      this.appList = JSON.parse(this.backupList)
    },
    async getAvator (val) {
      if (val && /^[0-9]*$/.test(val)) {
        let res = await this.$api.auth.getAvator({ mid: val })
        this.inviteeInfo = res
        this.filterAppList(res)
        return res
      } else {
        this.inviteeInfo = {}
      }
    },
    async fetchAppList () {
      let { list } = await this.$api.auth.fetchAppList({pn: 1, ps: 50})
      this.appList = list
      this.backupList = JSON.stringify(list)
    },
    submit () {
      this.$refs['form'].validate(async (value, field) => {
        if (value) {
          if (this.form.role === 30 && !this.form.limits.length) {
            this.$message({
              content: '请至少选择一个要授权的应用',
              type: 'exception',
              offset: 60,
              duration: 1500
            })
            return 
          }
          let res = await this.$api.auth.invite({
            level: this.form.role,
            mid_to: +this.form.invitee,
            client_ids: this.form.role === 20 ? '' : this.form.limits.join(',')
          })
          if (res.code === 0) {
            this.$message({
              content: '提交成功',
              type: 'success',
              offset: 60,
              duration: 1500
            })
            this.show = false
            this.$emit('refreshData')
          } else {
            this.$message({
              content: res.message,
              type: 'exception',
              offset: 60,
              duration: 1500
            })
          }
        }
      })
    },
    async handleCompanyDialog(bol) {
      this.show = bol
    },
    handleChange (val) {
      if (val === 20) { // 管理员
        this.form.limits = [
          '企业信息编辑权限',
          '申请应用权限',
          '应用管理权限',
          '授权开发者权限',
          '邀请管理员权限'
        ]
      } else {
        this.form.limits = []
        this.filterAppList()
      }
    }
  },
}
</script>
<style scoped lang="scss">
::v-deep .bcc-dialog__wrap .bcc-dialog .bcc-dialog__body {
  padding-bottom: 0!important;
}
.des {
  margin-top: 34px;
  margin-bottom: 16px;
}
.tip {
  font-size: 14px;
  color: #999;
}
.form-container {
  padding: 10px 40px;
  .role-tips {
    position: absolute;
    right: 155px;
    top: 7px;
  }
  .check-box {
    flex-direction: column;
    width: 390px;
    .bcc-checkbox {
      margin-left: 0;
      margin-top: 15px;
      &:first-child {
        margin-top: 10px;
      }
    }
  }
  .choose-app {
    margin-top: 8px;
    font-size: 14px;
    color: #999;
  }
  .backup-des {
    margin-top: 8px;
    color: #999;
    font-size: 14px;
  }
  .app-list-box {
    background: linear-gradient(180deg, #FFFFFF 0%, #FAFAFA 100%);
    border-radius: 4px;
    padding: 10px 20px 20px;
    overflow-y: scroll;
    height: 110px;
    margin-top: 10px;
    .bcc-checkbox { 
      color: #212121;
    }
  }
}
.invitee-info {
  display: flex;
  align-items: center;
  color: #212121;
  font-size: 12px;
  margin-top: 10px;
  img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 10px;
  }
}
</style>
